// Bengaluru aerial at night — our Karnataka home city, an engineered metropolis (Unsplash, ky1d-IWCBis)
const JOURNO_IMG =
    "https://images.unsplash.com/photo-1596176530529-78163a4f7af2?fm=jpg&q=70&w=1200&auto=format&fit=crop";

const POINTS = [
    {
        h: "PIME Talent Pipeline",
        b: "Our owned institute trains and vets specialist leads. We bypass agency attrition and the freelancer lottery — you always get the A-team.",
    },
    {
        h: "Hybrid AI · Human",
        b: "AI for velocity, journalists for integrity. Every artefact passes a Journalistic Audit before it leaves the studio. No AI slop.",
    },
    {
        h: "Direct-to-Journalist",
        b: "Relationship-led pitching with a Producer's Kit (B-roll, infographics, expert quotes) — response rates that traditional PR can't touch.",
    },
    {
        h: "External Media Department",
        b: "Embedded weekly stand-ups, shared OKRs, board-ready reporting. We act like your in-house team — minus the overhead and politics.",
    },
];

export default function Differentiators() {
    return (
        <section
            id="why"
            data-testid="differentiators-section"
            className="relative py-28 md:py-36 bg-[#0a0a0c]"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10">
                <div className="grid md:grid-cols-12 gap-10 items-start">
                    <div className="md:col-span-5 md:sticky md:top-28 reveal">
                        <div className="text-[11px] uppercase tracking-[0.3em] text-[#e6192b] mb-5">
                            ⎯⎯ §06 · Differentiators
                        </div>
                        <h2 className="font-serif-display text-5xl md:text-6xl leading-[0.95] tracking-tight mb-8">
                            Why brands hire us{" "}
                            <span className="italic text-[#a0a0ab]">
                                instead of
                            </span>{" "}
                            their agency.
                        </h2>
                        <div className="relative aspect-[4/5] overflow-hidden border border-[#26262a] group">
                            <img
                                src={JOURNO_IMG}
                                alt="Editorial journalism"
                                loading="lazy"
                                decoding="async"
                                className="w-full h-full object-cover grayscale-[35%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-[1500ms]"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0c] via-transparent to-transparent" />
                            <div className="absolute bottom-6 left-6 right-6">
                                <div className="text-[11px] uppercase tracking-[0.22em] text-[#e6192b] mb-2">
                                    Journalistic Audit
                                </div>
                                <p className="font-serif-display italic text-xl md:text-2xl leading-tight text-white">
                                    “If a real journalist wouldn&apos;t print
                                    it, we don&apos;t publish it.”
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="md:col-span-7 grid sm:grid-cols-2 gap-px bg-[#26262a] border border-[#26262a]">
                        {POINTS.map(({ h, b }, i) => (
                            <div
                                key={h}
                                data-testid={`diff-${i}`}
                                className="p-8 md:p-10 bg-[#050505] hover:bg-[#0a0a0c] transition-colors duration-500 reveal"
                                style={{ transitionDelay: `${i * 80}ms` }}
                            >
                                <span className="font-serif-display italic text-3xl text-[#e6192b]">
                                    0{i + 1}
                                </span>
                                <h3 className="mt-3 font-serif-display text-2xl md:text-3xl mb-4 leading-tight">
                                    {h}
                                </h3>
                                <p className="text-[#a0a0ab] leading-relaxed text-[15px]">
                                    {b}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
